import { Component, OnInit, OnDestroy } from '@angular/core';
import {AppDataService} from "../../../services/app-data.service";
import {FormBuilder, FormGroup} from "@angular/forms";
import {CompanyService} from "../../../services/company.service";
import { TranslationService } from '../../../services/translation.service';
import { BaseActionComponent } from './baseAction';


declare let $: any;
declare let Swal:any;

@Component({
    selector : 'imageShow-action',
    templateUrl:'imageShow.html'
})
export class ImageShowActionComponent extends BaseActionComponent{

  public dataList;
  public media
  public level=1;
  public text;
  public linkForm: FormGroup;
  public constructor(public translate: TranslationService,public _appData : AppDataService,public fb : FormBuilder, public _companyService : CompanyService) {
    super(translate,_appData,fb,_companyService)
  }
  public processData(action){
    if (!action){
      action={kind:'imageShow',param:{}}
    }
    let thumbnail=this.media.url
    if (this.selectedPack){
      action.param.url='pack-'+this.selectedPack.id+'-id-'+this.media.id
    }
    else{
      action.param.url='texture-'+this.media.id
    }
    if (this.text){
      action.param.text=this.text
    }
    else{
      action.param.text=''
    }
    action.param.room=this._appData.room.id;  
  }
    public gotoLink(item){
    window.open(item.url, '_blank');
  }
  public updateEmbed(){
    this.text=this.linkForm.controls['linkParam'].value;
  }
  public selectItem(item) {
    this.media=null
    for (let i = 0; i < this.dataList.length; i++) {
      if (this.dataList[i].id == item.id) {
          this.dataList[i].selected = true;
          this.media=item
      }
      else {
          this.dataList[i].selected = false;
      }
    }
  }  
  public reloadLocalPacks(){
    let list=[]
    if (this.selectedPack){
      list=this.selectedPack.images
    }
    else{
      if (this._appData.room.textures.images) {
        list=this._appData.room.textures.images
      }
    }
    this.dataList = []
    if (this.action.param && this.action.param.url && this.action.param.url.indexOf('http')>=0){
      list.forEach(ic => {
        ic.url = ic.url
        ic.selected = false        
        if (this.action.param) {
          if ((this.action.param.url) == ic.url) {
            ic.selected = true;
            this.media=ic
          }
        }
        this.dataList.push(ic);
      })  
    }
    else{
      if (this.selectedPack){
        list.forEach(ic => {
          ic.selected = false        
          if ((this.action.param && this.action.param.url) == 'pack-'+this.selectedPack.id+'-id-'+ic.id) {
              ic.selected = true;
              this.media=ic
          }
          this.dataList.push(ic);
        })  
      }
      else{
        //nao é um pack veio das texturas.
        list.forEach(ic => {
          ic.selected = false    
          if (!ic.id){ic.id=ic.transaction;}
          if (this.action.param.url){
            if ((this.action.param.url) == 'texture-'+ic.id) {
              ic.selected = true;
              this.media=ic
            }
          }    
          this.dataList.push(ic);
        })  
      }
    }
  }

  public childrenReloadData(){
    let list=[]
    let split=null
    if (this.action.param && this.action.param.url){
      split=this.action.param.url.split('-')
      if (split.length>0 && split[0]=='pack'){
        this.selectedPack=this._appData.room.packs[split[1]]
      }
    }
    if (this.action.param && this.action.param.text){
      this.text=this.action.param.text;
      this.linkForm = this.fb.group({
        linkParam: this.action.param.text,
      });
    }else{
      this.linkForm = this.fb.group({
        linkParam: '',
      });
      this.text='';
    }
    this.reloadLocalPacks();

  

  }

    public ngOnInit(): any {
      this.linkForm = this.fb.group({
        linkParam: '',
      });


    }


}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/actions/imageShow.ts